import { RootState } from 'reducers/rootReducer';
import { useSelector } from 'react-redux';
const useFormHasErrors = (formId: string) => {
    const errorCount = useSelector((state: RootState) => (state.form![formId] || {}).syncErrors);
    return errorCount > 0;
};
export default useFormHasErrors;
